export default "__VITE_ASSET__BSeQ9mpD__"